import {
    BILL_UPLOAD_DATA_GET_LIST_SUCCESS,
    CASH_REQUISITION_DETAILS_CASHFORM_RESET,
    CREATE_CASH_REQUISITION_DETAILS_FORM,
    CREATE_CASH_REQUISITION_DETAILS_FORM_FAILURE,
    CREATE_CASH_REQUISITION_DETAILS_FORM_REQUEST,
    CREATE_CASH_REQUISITION_DETAILS_FORM_SUCCESS,
    DELETE_CASH_REQUISITION_DETAILS_FORM_FAILURE,
    DELETE_CASH_REQUISITION_DETAILS_FORM_REQUEST,
    DELETE_CASH_REQUISITION_DETAILS_FORM_SUCCESS,
    FETCH_CASH_REQUISITION_DETAILS_BY_ID_FAILURE,
    FETCH_CASH_REQUISITION_DETAILS_BY_ID_REQUEST,
    FETCH_CASH_REQUISITION_DETAILS_BY_ID_SUCCESS,
    FETCH_CASH_REQUISITION_DETAILS_FORM_FAILURE,
    FETCH_CASH_REQUISITION_DETAILS_FORM_REQUEST,
    FETCH_CASH_REQUISITION_DETAILS_FORM_SUCCESS,
    FETCH_SINGLE_CASH_REQUISITION_DETAILS_FORM_FAILURE,
    FETCH_SINGLE_CASH_REQUISITION_DETAILS_FORM_REQUEST,
    FETCH_SINGLE_CASH_REQUISITION_DETAILS_FORM_SUCCESS,
    RESET_CASH_DETAILS_FORM_DATA,
    UPDATE_CASH_REQUISITION_DETAILS_FORM_FAILURE,
    UPDATE_CASH_REQUISITION_DETAILS_FORM_REQUEST,
    UPDATE_CASH_REQUISITION_DETAILS_FORM_SUCCESS
} from './CashRequisitionDetails.actionType';

export const CASH_REQUISITION_DETAILS = 'cashRequisitionDetails';

let initialState = {
    loading: false,
    cashRequisitionDetailsById: [],
    cashRequisitionDetailsList: [],
    detailsId: '',
    uploadId: '',
    // fldFKCRFId:1,
    cashDetailsForm: {
        fldIsBillIncluded: false,
        rowID: ''
    },
    DeleteDetailFormData: '',

    // cashForm: {},
    selectedCashRequisitionDetails: {},
    errorMessage: '',
    iperrorMessage: '',
    fldknittingProgramId: ''
};

export let CashRequisitionDetailsReducer = (state = initialState, action) => {
    let { type, payload, updatePayload } = action;

    console.log('updatePayload', updatePayload)

    switch (type) {
        case FETCH_CASH_REQUISITION_DETAILS_FORM_REQUEST:
        case FETCH_CASH_REQUISITION_DETAILS_BY_ID_REQUEST:
        case FETCH_SINGLE_CASH_REQUISITION_DETAILS_FORM_REQUEST:
        case CREATE_CASH_REQUISITION_DETAILS_FORM_REQUEST:
        case UPDATE_CASH_REQUISITION_DETAILS_FORM_REQUEST:
        case DELETE_CASH_REQUISITION_DETAILS_FORM_REQUEST:
            return {
                ...state,
                loading: true
            };
        case FETCH_CASH_REQUISITION_DETAILS_FORM_SUCCESS:
            return {
                ...state,
                loading: false,
                cashRequisitionDetailsList: updatePayload,
                detailsId: updatePayload
            };
        case FETCH_SINGLE_CASH_REQUISITION_DETAILS_FORM_SUCCESS:
            return {
                ...state,
                loading: false,
                cashDetailsForm: { ...updatePayload, rowID: state.cashDetailsForm.rowID }
            };
        case FETCH_CASH_REQUISITION_DETAILS_BY_ID_SUCCESS:
            return {
                ...state,
                loading: false,
                cashRequisitionDetailsById: updatePayload,
                selectedCashRequisitionDetails: updatePayload
            };
        case CREATE_CASH_REQUISITION_DETAILS_FORM:
            return {
                ...state,
                loading: false,
                cashDetailsForm: {
                    ...state.cashDetailsForm,
                    [payload.key]: payload.value
                }
            };
        case CREATE_CASH_REQUISITION_DETAILS_FORM_SUCCESS:
            return {
                ...state,
                loading: false,
                cashDetailsForm: { ...updatePayload, fldIsBillIncluded: state.cashDetailsForm.fldIsBillIncluded },
            };
        case UPDATE_CASH_REQUISITION_DETAILS_FORM_SUCCESS:
            return {
                ...state,
                loading: false,
                cashDetailsForm: { ...updatePayload, fldIsBillIncluded: state.cashDetailsForm.fldIsBillIncluded, rowID: state.cashDetailsForm.rowID },
            };
        case DELETE_CASH_REQUISITION_DETAILS_FORM_SUCCESS:
            return {
                ...state,
                loading: false,
                DeleteDetailFormData: updatePayload
            };
        case FETCH_CASH_REQUISITION_DETAILS_FORM_FAILURE:
        case FETCH_CASH_REQUISITION_DETAILS_BY_ID_FAILURE:
        case FETCH_SINGLE_CASH_REQUISITION_DETAILS_FORM_FAILURE:
        case CREATE_CASH_REQUISITION_DETAILS_FORM_FAILURE:
        case UPDATE_CASH_REQUISITION_DETAILS_FORM_FAILURE:
        case DELETE_CASH_REQUISITION_DETAILS_FORM_FAILURE:
            return {
                ...state,
                loading: false,
                errorMessage: updatePayload
            };

        case CASH_REQUISITION_DETAILS_CASHFORM_RESET:
            return {
                ...state,
                cashDetailsForm: '',
                selectedCashRequisitionDetails: {}
            };

        case RESET_CASH_DETAILS_FORM_DATA:
            return {
                ...state,
                cashDetailsForm: {},
            }

        case BILL_UPLOAD_DATA_GET_LIST_SUCCESS:
            return {
                ...state,
                loading: false,
                uploadPreviewImg: updatePayload
            }

        default:
            return state;
    }
};
